(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kg-hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kg-hero-carousel')) {
  customElements.define('kg-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.kg-hero__track');
      this.slides = Array.from(this.querySelectorAll('.kg-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('.kg-hero__dot'));
      this.toggle = this.querySelector('.kg-hero__pause');
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.paused = this.dataset.autoplay !== 'true' || this.reduced.matches;
      this.visible = false;
      this.querySelector('.kg-hero__controls')?.removeAttribute('hidden');
      this.querySelector('.kg-hero__prev')?.addEventListener('click', () => { this.pause(); this.go(this.index - 1); }, options);
      this.querySelector('.kg-hero__next')?.addEventListener('click', () => { this.pause(); this.go(this.index + 1); }, options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => { this.pause(); this.go(index); }, options));
      this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.updateToggle(); }, options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.addEventListener('focusin', (event) => { if (event.target !== this.toggle) this.pause(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => this.update(Math.round(this.track.scrollLeft / this.track.clientWidth)), 120);
      }, options);
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.pause(); }, options);
      this.mobile.addEventListener('change', () => this.updateHeight(), options);
      this.resizeObserver = new ResizeObserver(() => this.updateHeight());
      this.slides.forEach(slide => this.resizeObserver.observe(slide.querySelector('.kg-hero__inner')));
      document.addEventListener('shopify:block:select', (event) => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.pause(); this.go(index); }
      }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; }, { threshold: 0.25 });
      this.observer.observe(this);
      this.timer = setInterval(() => {
        if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.reduced.matches) this.go(this.index + 1);
      }, 7000);
      this.update(0);
      this.updateToggle();
    }
    go(index) {
      const next = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: this.reduced.matches ? 'instant' : 'smooth' });
    }
    update(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.dataset.activeIndex = this.index;
      this.updateHeight();
      this.slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== this.index));
        slide.inert = i !== this.index;
      });
      this.dots.forEach((dot, i) => {
        if (i === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }
    updateHeight() {
      if (!this.mobile.matches) {
        this.track.style.removeProperty('--kg-hero-mobile-height');
        return;
      }
      const content = this.slides[this.index]?.querySelector('.kg-hero__inner');
      if (content) this.track.style.setProperty('--kg-hero-mobile-height', `${Math.ceil(content.getBoundingClientRect().height)}px`);
    }
    pause() { this.paused = true; this.updateToggle(); }
    updateToggle() {
      if (this.toggle) {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.play : this.dataset.pause);
        this.toggle.querySelector('span').textContent = this.paused ? '▷' : 'Ⅱ';
      }
    }
    disconnectedCallback() {
      this.abort?.abort(); this.abort = null;
      clearInterval(this.timer); clearTimeout(this.scrollTimer);
      this.observer?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kg-testimonials-compact"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kg-compact-reviews')) {
  customElements.define('kg-compact-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.kg-reviews__track');
      this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
      if (!this.track) return;
      this.querySelector('.kg-reviews__controls')?.removeAttribute('hidden');
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.buttons.forEach(button => {
          button.disabled = Number(button.dataset.direction) < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max - 2;
        });
      };
      this.buttons.forEach(button => button.addEventListener('click', () => {
        const card = this.track.querySelector('.kg-reviews__card');
        const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({left: distance * Number(button.dataset.direction), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, options));
      this.track.addEventListener('scroll', update, options);
      this.resize = new ResizeObserver(update);
      this.resize.observe(this.track);
      document.addEventListener('shopify:block:select', event => {
        const card = Array.from(this.track.children).find(item => {
          try { return JSON.parse(item.getAttribute('data-shopify-editor-block') || '{}').id === event.detail.blockId; } catch { return false; }
        });
        card?.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'});
      }, options);
      update();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
